// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__3zfDl","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__Uy-Sl"};